var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8003 22.6C28.5337 24 27.4003 25.0667 26.0003 25.2667C23.8003 25.6 20.1337 26 16.0003 26C11.9337 26 8.26699 25.6 6.00033 25.2667C4.60033 25.0667 3.46699 24 3.20033 22.6C2.93366 21.0667 2.66699 18.8 2.66699 16C2.66699 13.2 2.93366 10.9333 3.20033 9.4C3.46699 8 4.60033 6.93333 6.00033 6.73333C8.20033 6.4 11.867 6 16.0003 6C20.1337 6 23.7337 6.4 26.0003 6.73333C27.4003 6.93333 28.5337 8 28.8003 9.4C29.067 10.9333 29.4003 13.2 29.4003 16C29.3337 18.8 29.067 21.0667 28.8003 22.6Z",
    fill: "#FF3D00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.333 20.6667V11.3334L21.333 16L13.333 20.6667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.829ccf9ec4a917a6c30655cf54a55c66.svg";
export { ForwardRef as ReactComponent };